/**
 * Map Grid mosaic session for the connected camera.
 * Persisted on the camera mapping JSON (`mapGridMosaic`) so any browser
 * that loads the cam file can reopen the last scan.
 */
import { isAllowedMosaicUrl } from '../CrowdCount/signedAssetCache';
import camMap from './mapLogic';

export { isAllowedMosaicUrl };

const toSession = (stored) => {
  if (!stored?.mosaicUrl || !isAllowedMosaicUrl(stored.mosaicUrl)) return null;
  return {
    mosaicUrl: stored.mosaicUrl,
    mosaicWidth: stored.mosaicWidth ?? null,
    mosaicHeight: stored.mosaicHeight ?? null,
    grid: stored.grid ?? null,
  };
};

export const loadMosaicSession = (camera) => {
  if (!camera) return null;
  return toSession(camMap.getMapGridMosaic());
};

export const saveMosaicSession = async (session) => {
  if (!session?.mosaicUrl || !isAllowedMosaicUrl(session.mosaicUrl)) return false;
  return camMap.saveMapGridMosaic(session);
};

export const clearMosaicSession = async () => camMap.clearMapGridMosaic();
